import { api } from './client';
import type { StravaStatus } from '@/types/User';

export interface StravaSyncResult {
  /** Number of activities pulled from Strava and emitted to Kafka. Cardio ingests them asynchronously. */
  emitted: number;
}

export const stravaApi = {
  status: () => api<StravaStatus>('/api/strava/status'),
  disconnect: () => api<void>('/api/strava/disconnect', { method: 'POST' }),
  sync: () => api<StravaSyncResult>('/api/strava/sync', { method: 'POST' }),
  authorizeUrl: () => '/api/strava/authorize',
};
